import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { Clickable as BaseClickable } from 'reakit';
import { CustomLinkComponentProps } from './types';

export type BehaviourReactRouterLinkProps = CustomLinkComponentProps;

export const BehaviourReactRouterLink = React.forwardRef<
    HTMLAnchorElement,
    BehaviourReactRouterLinkProps
>(function ({ href, ...props }, ref) {
    return <BaseClickable ref={ref} as={ReactRouterLink} to={href} {...props} />;
});
